import * as React from "react";

export interface UploadIconProps {}

export const UploadIcon = (props: UploadIconProps) => {
    return (
        
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 50 50" enableBackground="new 0 0 50 50" className="upload-icon">
<path fill="#FFFFFF" d="M48.8,44.7H1.2c-0.6,0-1-0.5-1-1v-31c0-0.6,0.4-1,1-1h7.5V6H34v5.6h14.8c0.5,0,1,0.4,1,1v31
	C49.8,44.2,49.3,44.7,48.8,44.7z"/>
<g>
	<g>
		<path fill="#959595" d="M40.8,32.2l-4.3-4.3l3.2-1.6c0.2-0.1,0.4-0.3,0.3-0.6c0-0.2-0.2-0.5-0.4-0.5l-5.3-1.8V12.8h1.3
			c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-1.3V5.9c0-0.3-0.3-0.6-0.6-0.6H8.5c-0.3,0-0.6,0.3-0.6,0.6v5.7H6.5
			c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h1.4V27c0,0.3,0.3,0.6,0.6,0.6h20.4l2.1,6.2c0.1,0.2,0.3,0.4,0.5,0.4
			c0.2,0,0.5-0.1,0.6-0.3l1.6-3.2L38,35c0.1,0.1,0.3,0.2,0.4,0.2c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0
			c0.1,0,0.1-0.1,0.2-0.1l2-2c0.1-0.1,0.2-0.3,0.2-0.4C41,32.5,41,32.3,40.8,32.2z M9.1,26.4l0-19.9h24.1l0,16.4L27.7,21
			c-0.2-0.1-0.5,0-0.6,0.2c0,0,0,0,0,0c-0.2,0.2-0.2,0.4-0.2,0.6l1.6,4.6H9.1z M38.5,33.7l-4.5-4.5c-0.1-0.1-0.3-0.2-0.5-0.2
			c-0.2,0-0.4,0.2-0.4,0.3L31.7,32l-1.8-5.2c0,0,0,0,0-0.1l-1.4-4.2l9.5,3.3l-2.7,1.3c-0.2,0.1-0.3,0.3-0.3,0.4c0,0.2,0,0.4,0.2,0.5
			l4.5,4.5L38.5,33.7z"/>
		<path fill="#959595" d="M38.9,35c-0.1,0.1-0.1,0.1-0.2,0.1C38.8,35.1,38.8,35.1,38.9,35z"/>
	</g>
</g>
<g>
	<g>
		<path fill="#959595" d="M43.5,12.8h-3.9c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h3.9c0.3,0,0.6,0.3,0.6,0.6S43.8,12.8,43.5,12.8z"/>
	</g>
	<g>
		<path fill="#959595" d="M49.1,14.6c-0.3,0-0.6-0.3-0.6-0.6v-1.2h-1.2c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h1.8
			c0.3,0,0.6,0.3,0.6,0.6V14C49.8,14.4,49.5,14.6,49.1,14.6z"/>
	</g>
	<g>
		<path fill="#959595" d="M49.1,38.8c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4
			C49.8,38.5,49.5,38.8,49.1,38.8z M49.1,30.8c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4
			C49.8,30.5,49.5,30.8,49.1,30.8z M49.1,22.7c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4
			C49.8,22.4,49.5,22.7,49.1,22.7z"/>
	</g>
	<g>
		<path fill="#959595" d="M49.1,44.7h-1.8c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h1.2v-1.2c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v1.8
			C49.8,44.4,49.5,44.7,49.1,44.7z"/>
	</g>
	<g>
		<path fill="#959595" d="M43.9,44.7h-3.4c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h3.4c0.3,0,0.6,0.3,0.6,0.6S44.2,44.7,43.9,44.7z
			 M37,44.7h-3.4c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6H37c0.3,0,0.6,0.3,0.6,0.6S37.4,44.7,37,44.7z M30.2,44.7h-3.4
			c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h3.4c0.3,0,0.6,0.3,0.6,0.6C30.8,44.4,30.5,44.7,30.2,44.7z M23.3,44.7h-3.4
			c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h3.4c0.3,0,0.6,0.3,0.6,0.6S23.6,44.7,23.3,44.7z M16.4,44.7H13c-0.3,0-0.6-0.3-0.6-0.6
			s0.3-0.6,0.6-0.6h3.4c0.3,0,0.6,0.3,0.6,0.6S16.7,44.7,16.4,44.7z M9.5,44.7H6.1c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h3.4
			c0.3,0,0.6,0.3,0.6,0.6C10.1,44.4,9.9,44.7,9.5,44.7z"/>
	</g>
	<g>
		<path fill="#959595" d="M2.7,44.7H0.9c-0.3,0-0.6-0.3-0.6-0.6v-1.8c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v1.2h1.2
			c0.3,0,0.6,0.3,0.6,0.6S3,44.7,2.7,44.7z"/>
	</g>
	<g>
		<path fill="#959595" d="M0.9,38.8c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4C1.5,38.5,1.2,38.8,0.9,38.8z
			 M0.9,30.8c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4C1.5,30.5,1.2,30.8,0.9,30.8z M0.9,22.7
			c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4C1.5,22.4,1.2,22.7,0.9,22.7z"/>
	</g>
	<g>
		<path fill="#959595" d="M0.9,14.6c-0.3,0-0.6-0.3-0.6-0.6v-1.8c0-0.3,0.3-0.6,0.6-0.6h1.8c0.3,0,0.6,0.3,0.6,0.6S3,12.8,2.7,12.8H1.5
			V14C1.5,14.4,1.2,14.6,0.9,14.6z"/>
	</g>
</g>
<path fill="#FB9590" d="M23.5,12.2c-1.1,0-2,0.9-2.5,1.8c-0.4-0.9-1.4-1.8-2.5-1.8c-1.5,0-2.7,1.2-2.7,2.7c0,3.1,3.1,3.9,5.2,6.9
	c2-3,5.2-3.9,5.2-6.9C26.2,13.4,25,12.2,23.5,12.2L23.5,12.2z"/>
</svg>


    );
};
